import { empty, floatval, strval } from '../../../php-compat';
import { readItemField } from '../../../compile/item-field-reader';
import { fromBaseClone, fromBaseRecord, fromBaseUuid } from '../../../compile/from-base-context';
import type { FromBaseRow as Row } from '../../../compile/from-base-context';

const displayColumns = ['item_private', 'item_deleted', 'item_archived', 'item_created_by_id',
    'item_id', 'item_name', 'item_type', 'item_description', 'flavor_text', 'source_link',
    'preview', 'homebrew', 'item_price'] as const;

/** PHP: build_item_arr (includes/functions/db/items/build_item_arr.php:56),
 * items/source projection only. Raw media is consumed by later stages. */
export function constructDefinitionItemsFromBase(source: Row): Row {
    const items: Row = {};
    for (const name of displayColumns) items[name] = readItemField(source, name);
    const field = (name: string) => readItemField({ items }, name);
    for (const name of ['source_link', 'item_description', 'flavor_text'])
        if (strval(field(name) ?? '') === '') delete items[name];
    for (const name of ['preview', 'homebrew'])
        if (strval(field(name) ?? '0') === '0') delete items[name];
    for (const name of ['item_private', 'item_deleted', 'item_archived'])
        if (empty(field(name))) delete items[name];
    if (floatval(field('item_price') ?? 0).value === 0) delete items.item_price;
    const sourceId = strval(readItemField(source, 'source_id') ?? '');
    if (sourceId !== '' && sourceId !== 'D887B8A7-2CED-AB81-3E4E-DDDF4ACD91AE') {
        items.source = Object.fromEntries(['source_id', 'source_name', 'source_abbreviation', 'source_license_kind']
            .map(name => [name, readItemField(source, name) ?? '']));
    }
    return { items };
}

/** SELECT-only definition shape. C1 emits both canonical layers and legacy
 * mirrors; keep one authoritative copy and never attach the raw catalog. */
export function constructDefinitionSourceFromBase(source: Row): Row {
    if (!fromBaseRecord(source.items) || !fromBaseUuid(readItemField(source, 'item_id'))
        || !(fromBaseRecord(source.item_layer_types) || Array.isArray(source.item_layer_types)
            && source.item_layer_types.length === 0)) throw new TypeError('Invalid raw definition source');
    return { ...constructDefinitionItemsFromBase(source), item_layer_types: fromBaseClone(source.item_layer_types) };
}
